import { Component, inject } from '@angular/core';

import { AppInsightsService } from '~/core/services/appinsights.service';
import { AppConfigService } from '~/core/services/appconfig.service';
import { AppSettingsService } from '~/core/services/appsettings.service';

import { AppConfig } from '~/core/models/appconfig';
import { AppSettings } from '~/core/models/appsettings';

@Component({
    template: '',
    standalone: false
})

export class BaseComponent {
    public appConfig: AppConfig = new AppConfig();
    public appSettings: AppSettings = new AppSettings();
    public permissions: Permissions | undefined;

    public title: string = "";
    public isLoading = true;

    private _appInsightsService: AppInsightsService = inject(AppInsightsService);
    private _appConfigService: AppConfigService = inject(AppConfigService);
    private _appSettingsService: AppSettingsService = inject(AppSettingsService);

    //*************************************************************************
    //  Component Life-Cycle Methods
    //*************************************************************************
    public async ngOnInit() {
        this.appConfig = this._appConfigService.getConfig();
        this.appSettings = await this._appSettingsService.getSettings();
    }

    //*************************************************************************
    //  Public Methods
    //*************************************************************************
    public logAppInsightsEvent(type: string, message: string) {
        this._appInsightsService.logEvent(`User Action: ${type}`, { "Event": message });
    }

    public getPath(): string {
        return window.location.pathname;
    }

}
